// extracted by mini-css-extract-plugin
export default {"price":"dqa-z","onSale":"eqa-z","msrpLabelPrice":"fqa-z","msrpLabel":"gqa-z","originalPrice":"hqa-z"};